module.exports = __webpack_public_path__ + "img/screenshot05.b2137a79.png";